<template>
  <invoice-list :editable="true" style="min-height:700px;"/>
</template>
<script>
import InvoiceList from './InvoiceList.vue'
export default {
  components: { InvoiceList }
}
</script>